<mat-card>
  <mat-card-header>
    <mat-card-title>Player Email History</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <ag-grid-angular
      id="playerEmailHistoryGrid"
      class="ag-theme-quartz margin-top-med margin-bottom-med"
      data-testid="player-email-history-grid"
      [tooltipShowDelay]="0"
      rowClass="table-row"
      domLayout="autoHeight"
      overlayNoRowsTemplate="<span>This player has no email addresses associated to their causable account</span>"
      (firstDataRendered)="onFirstDataRendered($event)"
      (gridSizeChanged)="onGridSizeChanged($event)"
      [loading]="uiState == uiStateEnum.ShowLoading"
      [rowData]="playerEmails"
      [columnDefs]="playerEmailColDefs">
    </ag-grid-angular>
  </mat-card-content>
</mat-card>
